/**
 * Methods for configuring and managing push notifications from Firebase Cloud
 * Messaging in a ToDesktop application.
 *
 * @remarks
 * This package exposes a number of methods for configuring and managing push
 * notifications from Firebase Cloud Messaging.
 *
 * @experimental
 * @public
 * @packageDocumentation
 */
import { isCompatibleWithBackend, setupAddEventListener, } from "@todesktop/client-util";
const _pushNotificationsEventMappings = {
    start: "pushNotifications.start",
    error: "pushNotifications.error",
    tokenUpdate: "pushNotifications.tokenUpdate",
    receive: "pushNotifications.receive",
};
/**
 * Starts the push notification service.
 *
 * @param sender - Firebase Sender ID (legacy) or Firebase Sender Object (new)
 * @public
 */
export async function start(sender, options) {
    if (typeof sender === "object" &&
        sender !== null &&
        "appId" in sender &&
        !supportsNewFCMService()) {
        throw new Error("The new push notifications API is not supported in this version of ToDesktop. See here: https://www.todesktop.com/docs/miscellaneous/push-notifications");
    }
    return window["todesktop"].pushNotifications.start(sender, options);
}
/**
 * Checks if the new push notifications API (using the firebase sender object) is
 * supported.
 *
 * @public
 */
export function supportsNewFCMService() {
    return isCompatibleWithBackend("6.0.0");
}
/**
 * @public
 */
export const on = setupAddEventListener(_pushNotificationsEventMappings);
